module.exports = __webpack_public_path__ + "static/media/logo_pl_fr.32d0682f.svg";